import { render, staticRenderFns } from "./ResultNormalAuthPop.vue?vue&type=template&id=61e1363c&scoped=true&"
import script from "./ResultNormalAuthPop.vue?vue&type=script&lang=js&"
export * from "./ResultNormalAuthPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e1363c",
  null
  
)

export default component.exports